// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3seC5","index":"styles_index__32D2c"};